module.exports = __webpack_public_path__ + "img/About_Employers_DARK-02.2e522e4.svg";